import React, { Component } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { FaPowerOff, FaCoffee } from 'react-icons/fa';
import { GoMarkGithub, GoSmiley, GoClippy } from 'react-icons/go';
import { MdDashboard, MdLibraryAdd, MdEmail } from 'react-icons/md';
import './navbar.css';
import firebaseInit from '../auth/firebaseInit';

export default class Navbar extends Component {
  logout = () => {
    firebaseInit.auth().signOut();
  };

  setNewPageToRender = selected => {
    this.props.setRenderedPage(selected);
  };

  getUserDetails = () => {
    return firebaseInit.auth().currentUser;
  };

  render() {
    return (
      <SideNav
        onSelect={selected => {
          switch (selected) {
            case 'logout':
              this.logout();
              break;
            case 'dashboards':
              this.setNewPageToRender(selected);
              break;
            case 'newDashboard':
              this.setNewPageToRender(selected);
              break;
            case 'feedback':
              window.open('mailto:singh_kshitij@yahoo.com', '_blank');
              break;
            case 'coffee':
              window.open(
                'https://paypal.me/ikshitijsingh?locale.x=en_GB',
                '_blank'
              );
              break;
            case 'github':
              window.open('https://github.com/singhkshitij/kanbang', '_blank');
              break;
            case 'dev':
              window.open('https://github.com/singhkshitij/', '_blank');
              break;
            case 'license':
              window.open(
                'https://github.com/singhkshitij/kanbang/blob/master/LICENSE',
                '_blank'
              );
              break;
            default:
              break;
          }
        }}>
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected={this.props.getRenderedPage()}>
          <NavItem eventKey="profile" disabled>
            <NavIcon>
              <img
                src={this.getUserDetails().photoURL}
                alt={this.getUserDetails().displayName}
                style={{
                  height: '40px',
                  width: '40px',
                  borderRadius: '20px',
                  margin: '5px'
                }}
              />
            </NavIcon>
            <NavText
              style={{
                float: 'left',
                fontSize: '1.3em',
                marginLeft: '10px',
                color: '#EEEEEE'
              }}>
              {this.getUserDetails().displayName}
            </NavText>
          </NavItem>
          <NavItem eventKey="dashboards">
            <NavIcon>
              <MdDashboard style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Dashboards</NavText>
          </NavItem>
          <NavItem eventKey="newDashboard">
            <NavIcon>
              <MdLibraryAdd style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Add dashboard</NavText>
          </NavItem>

          <hr style={{ color: '#0288D1' }} />

          <NavItem eventKey="coffee">
            <NavIcon>
              <FaCoffee style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Sponsor a coffee</NavText>
          </NavItem>
          <NavItem eventKey="feedback">
            <NavIcon>
              <MdEmail style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Give feedback</NavText>
          </NavItem>
          <NavItem eventKey="github">
            <NavIcon>
              <GoMarkGithub style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Github</NavText>
          </NavItem>
          <NavItem eventKey="dev">
            <NavIcon>
              <GoSmiley style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Developer</NavText>
          </NavItem>
          <NavItem eventKey="license">
            <NavIcon>
              <GoClippy style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>License</NavText>
          </NavItem>
          <NavItem eventKey="logout">
            <NavIcon>
              <FaPowerOff style={{ fontSize: '1.2em' }} />
            </NavIcon>
            <NavText>Logout</NavText>
          </NavItem>
          <span className="version-details">v1.0.0</span>
        </SideNav.Nav>
      </SideNav>
    );
  }
}
